import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'

export default class AutoCountModel {
  constructor() {
    this._id = null
    this._list = null

    this.createSignal()
  }

  createSignal() {
    signal.on('BUTTON:prevauto', this.makeCountHandler(-1).bind(this))
    signal.on('BUTTON:nextauto', this.makeCountHandler(1).bind(this))
  }

  makeCountHandler(delta) {
    const self = this
    return function () {
      self.setID(self._id + delta)
    }
  }

  getList() {
    return this._list
  }

  setList(value) {
    this._list = value
  }

  getID() {
    return this._id
  }

  getMaxID() {
    return this._list.length - 1
  }

  getValue() {
    return this._list[this._id]
  }

  setID(value) {
    this._id = value < 0 ? 0 : value > this.getMaxID() ? this.getMaxID() : value
    StoreageService.set('auto', this._id)
    signal.dispatch('MODEL:AUTO', this._list[this._id])
  }
}
